import { useTranslation } from 'react-i18next';
import { Text } from '@lili/lili-frontend-common';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { EddYesNo } from '@Pages/happyFlowPages/eddQuestions/consts';

export const FundTransferForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[24px] mt-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_FUND_TRANSFER}>
        {({ onChange, value }) => {
          const isYesSelected = value === EddYesNo.YES;

          return (
            <div className='flex flex-col gap-[16px]'>
              <Text.H9 className='text-text-main-primary'>
                {t('organic.fundTransfer.title')}
              </Text.H9>
              <div className={'flex flex-col gap-[24px]'}>
                <div className='flex flex-col gap-2'>
                  <CustomRadioButton
                    label={t('organic.fundTransfer.no')}
                    value={EddYesNo.NO}
                    inputId='fund-transfer-no'
                    onChange={onChange}
                    checked={value === EddYesNo.NO}
                    name={EddEmbeddedFields.EDD_FUND_TRANSFER}
                  />
                  <CustomRadioButton
                    label={t('organic.fundTransfer.yes')}
                    value={EddYesNo.YES}
                    inputId='fund-transfer-yes'
                    onChange={onChange}
                    checked={value === EddYesNo.YES}
                    name={EddEmbeddedFields.EDD_FUND_TRANSFER}
                  />
                </div>

                {isYesSelected && (
                  <ControllerWrapper name={EddEmbeddedFields.EDD_FUND_TRANSFER_US}>
                    {({ onChange: onFollowUpChange, value: followUpValue }) => (
                      <div className='flex flex-col gap-[16px]'>
                        <Text.H9 className='text-text-main-primary'>
                          {t('organic.fundTransfer.followUpTitle')}
                        </Text.H9>
                        <div className='flex flex-col gap-2'>
                          <CustomRadioButton
                            label={t('organic.fundTransfer.no')}
                            value={EddYesNo.NO}
                            inputId='fund-transfer-us-no'
                            onChange={onFollowUpChange}
                            checked={followUpValue === EddYesNo.NO}
                            name={EddEmbeddedFields.EDD_FUND_TRANSFER_US}
                          />
                          <CustomRadioButton
                            label={t('organic.fundTransfer.yes')}
                            value={EddYesNo.YES}
                            inputId='fund-transfer-us-yes'
                            onChange={onFollowUpChange}
                            checked={followUpValue === EddYesNo.YES}
                            name={EddEmbeddedFields.EDD_FUND_TRANSFER_US}
                          />
                        </div>
                      </div>
                    )}
                  </ControllerWrapper>
                )}
              </div>
            </div>
          );
        }}
      </ControllerWrapper>
    </div>
  );
};
